var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExcluded(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "19px",
    height: "19px",
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9.5 9.5 L 17.8125 9.5 L 17.8125 17.8125 L 9.5 17.8125 Z M 9.5 9.5 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.78125 9.921875 C 15.914062 9.921875 17.640625 11.652344 17.640625 13.78125 C 17.640625 15.914062 15.914062 17.640625 13.78125 17.640625 C 11.652344 17.640625 9.921875 15.914062 9.921875 13.78125 C 9.921875 11.652344 11.652344 9.921875 13.78125 9.921875 Z M 13.78125 9.921875 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 11 11 L 16 11 L 16 16 L 11 16 Z M 11 11 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.78125 9.921875 C 15.914062 9.921875 17.640625 11.652344 17.640625 13.78125 C 17.640625 15.914062 15.914062 17.640625 13.78125 17.640625 C 11.652344 17.640625 9.921875 15.914062 9.921875 13.78125 C 9.921875 11.652344 11.652344 9.921875 13.78125 9.921875 Z M 13.78125 9.921875 "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(18.823529%,24.705882%,27.843137%)",
      fillOpacity: 1
    },
    d: "M 14.703125 1.46875 L 2.941406 1.46875 C 2.132812 1.46875 1.480469 2.132812 1.480469 2.941406 L 1.46875 16.171875 L 4.410156 13.234375 L 14.703125 13.234375 C 15.511719 13.234375 16.171875 12.570312 16.171875 11.765625 L 16.171875 2.941406 C 16.171875 2.132812 15.511719 1.46875 14.703125 1.46875 Z M 12.496094 10.292969 L 5.144531 10.292969 C 4.742188 10.292969 4.410156 9.960938 4.410156 9.554688 C 4.410156 9.152344 4.742188 8.824219 5.144531 8.824219 L 12.496094 8.824219 C 12.898438 8.824219 13.234375 9.152344 13.234375 9.554688 C 13.234375 9.960938 12.898438 10.292969 12.496094 10.292969 Z M 12.496094 8.085938 L 5.144531 8.085938 C 4.742188 8.085938 4.410156 7.757812 4.410156 7.351562 C 4.410156 6.949219 4.742188 6.613281 5.144531 6.613281 L 12.496094 6.613281 C 12.898438 6.613281 13.234375 6.949219 13.234375 7.351562 C 13.234375 7.757812 12.898438 8.085938 12.496094 8.085938 Z M 12.496094 5.882812 L 5.144531 5.882812 C 4.742188 5.882812 4.410156 5.546875 4.410156 5.144531 C 4.410156 4.742188 4.742188 4.410156 5.144531 4.410156 L 12.496094 4.410156 C 12.898438 4.410156 13.234375 4.742188 13.234375 5.144531 C 13.234375 5.546875 12.898438 5.882812 12.496094 5.882812 Z M 12.496094 5.882812 "
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(18.823529%,24.705882%,27.843137%)",
      fillOpacity: 1
    },
    d: "M 13.78125 9.921875 C 15.914062 9.921875 17.640625 11.652344 17.640625 13.78125 C 17.640625 15.914062 15.914062 17.640625 13.78125 17.640625 C 11.652344 17.640625 9.921875 15.914062 9.921875 13.78125 C 9.921875 11.652344 11.652344 9.921875 13.78125 9.921875 Z M 13.78125 9.921875 "
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 15.808594 11.757812 C 15.683594 11.632812 15.484375 11.632812 15.355469 11.757812 L 13.78125 13.332031 L 12.207031 11.757812 C 12.082031 11.632812 11.882812 11.632812 11.757812 11.757812 C 11.632812 11.882812 11.632812 12.082031 11.757812 12.207031 L 13.332031 13.78125 L 11.757812 15.355469 C 11.632812 15.484375 11.632812 15.683594 11.757812 15.808594 C 11.882812 15.933594 12.082031 15.933594 12.207031 15.808594 L 13.78125 14.234375 L 15.355469 15.808594 C 15.484375 15.933594 15.683594 15.933594 15.808594 15.808594 C 15.933594 15.683594 15.933594 15.484375 15.808594 15.355469 L 14.234375 13.78125 L 15.808594 12.207031 C 15.933594 12.089844 15.933594 11.882812 15.808594 11.757812 Z M 15.808594 11.757812 "
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 0.8125,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 10.154607 6.907896 C 11.953538 6.907896 13.404196 8.361432 13.404196 10.154607 C 13.404196 11.953538 11.953538 13.404196 10.154607 13.404196 C 8.361432 13.404196 6.907896 11.953538 6.907896 10.154607 C 6.907896 8.361432 8.361432 6.907896 10.154607 6.907896 Z M 10.154607 6.907896 ",
    transform: "matrix(1.357143,0,0,1.357143,0,0)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcluded);
export default __webpack_public_path__ + "static/media/excluded.5be89ae22c17fb40808e74fe049e7897.svg";
export { ForwardRef as ReactComponent };